/**
 * @file utils.ts
 *
 * @fileoverview Exports dates utils.
 */

import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';

export const dateLocalesMap = { fr, de };
